import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { MapPin, Globe } from 'lucide-react';
import { useData } from '../context/DataContext';

const CountryModal = ({ open, onSelectCountry }) => {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const { countries, loading } = useData();

  const handleConfirm = () => {
    if (selectedCountry) {
      onSelectCountry(selectedCountry);
    }
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center">
              <Globe className="h-8 w-8 text-white" />
            </div>
          </div>
          <DialogTitle className="text-center text-2xl">
            ¿Desde dónde nos visitas?
          </DialogTitle>
          <DialogDescription className="text-center">
            Selecciona tu país para ver las clínicas dentales más cercanas a ti
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-3 py-4">
          {loading ? (
            <div className="text-center py-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500 mx-auto"></div>
            </div>
          ) : (
            countries.map((country) => (
              <div
                key={country.code}
                onClick={() => setSelectedCountry(country.code)}
                className={`p-4 rounded-lg border-2 cursor-pointer transition-all duration-200 ${
                  selectedCountry === country.code
                    ? 'border-cyan-500 bg-cyan-50 shadow-md scale-105'
                    : 'border-gray-200 hover:border-cyan-300 hover:bg-gray-50'
                }`}
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3">
                    <span className="text-3xl">{country.flag}</span>
                    <div>
                      <h3 className="font-semibold text-gray-900">{country.name}</h3>
                      <p className="text-sm text-gray-500">Ver clínicas disponibles</p>
                    </div>
                  </div>
                  {selectedCountry === country.code && (
                    <div className="w-6 h-6 bg-cyan-500 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4 text-white" fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" stroke="currentColor">
                        <path d="M5 13l4 4L19 7"></path>
                      </svg>
                    </div>
                  )}
                </div>
              </div>
            ))
          )}
        </div>

        <div className="flex flex-col gap-2">
          <Button
            onClick={handleConfirm}
            disabled={!selectedCountry}
            className="w-full bg-cyan-500 hover:bg-cyan-600 text-white"
          >
            <MapPin className="h-4 w-4 mr-2" />
            Continuar
          </Button>
          <p className="text-xs text-gray-500 text-center">
            Puedes cambiar tu país en cualquier momento desde los filtros
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CountryModal;
